import { ToothRestorationEnum } from "requests";

export const RESTORATION_OPTIONS = [
  {
    value: ToothRestorationEnum.Restoratives,
    label: "Restorative(s)",
    name: "restoratives"
  },
  { value: ToothRestorationEnum.CrownPrep, label: "Crown Prep" },
  {
    value: ToothRestorationEnum.CrCementation,
    label: "CR cementation",
    name: "crCementation"
  }
];
